export const assetDetails = [
    {  
		checkbox: true,
		name: "Dell Laptop",
		user: "Anthony Lewis",
		image_url:"assets/img/users/user-32.jpg",
		purchase_date: "12/09/2024",
		warrenty:"12 months",
		warrenty_end:"12/09/2024",
		status:"Active",
        key:1
	},
	{   
		checkbox: true,
		name: "Canon Portable Printer",
		image_url:"assets/img/users/user-09.jpg",
		user: "Brian Villalobos",
		purchase_date: "24/10/2024",
		warrenty:"12 months",
		warrenty_end:"24/10/2024 ",
		status:"Active",
        key:2
	},
	{
		checkbox: true,
		name: "Dell Laptop",
		image_url:"assets/img/users/user-38.jpg",
		user: "Sophie Headrick",
		purchase_date: "18/02/2024",
		warrenty:"12 months",
		warrenty_end:"18/02/2024",
		status:"Active",
        key:3
	},
	{
		checkbox: true,
		name: "Dell Laptop",
		image_url:"assets/img/users/user-33.jpg",
		user: "Stephan Peralt",
		purchase_date: "17/10/2024",
		warrenty:"12 months",
		warrenty_end:"17/10/2024",
		status:"Active",
        key:4
	},
	{
		checkbox: true,
		name: "Dell Laptop",
		image_url:"assets/img/users/user-27.jpg",
		user: "Thomas Bordelon",
		purchase_date: "20/07/2024",
		warrenty:"12 months",
		warrenty_end:"20/07/2024",
		status:"Active",
        key:5
	},
	{
		checkbox: true,
		name: "Dell Laptop",
		image_url:"assets/img/users/user-32.jpg",
		user: "Doglas Martini",
		purchase_date: "10/04/2024",
		warrenty:"12 months",
		warrenty_end:"10/04/2024",
		status:"Active",
        key:6
	},
	{
		checkbox: true,
		name: "Dell Laptop",
		image_url:"assets/img/users/user-05.jpg",
		user: "Cameron Drake",
		purchase_date: "29/08/2024",
		warrenty:"12 months",
		warrenty_end:"29/08/2024",
		status:"Active",
        key:7
	},
	{
		checkbox: true,
		name: "Dell Laptop",
		image_url:"assets/img/users/user-30.jpg",
		user: "Harvey Smith",
		purchase_date: "22/02/2024",
		warrenty:"12 months",
		warrenty_end:"22/02/2024",
		status:"Inactive",
        key:8
	},
	{
		checkbox: true,
		name: "Dell Laptop",
		image_url:"assets/img/users/user-16.jpg",
		user: "Michael Walker",
		purchase_date: "03/11/2024",
		warrenty:"12 months",
		warrenty_end:"03/11/2024",
		status:"Active",
        key:9
	},
	{
		checkbox: true,
		name: "Dell Laptop",
		image_url:"assets/img/users/user-07.jpg",
		user: "Doris Crowley",
		purchase_date: "17/12/2024",
		warrenty:"12 months",
		warrenty_end:"17/12/2024",
		status:"Active",
        key:10
	}
];
